import { UnleashClient, IConfig, } from 'unleash-proxy-client';

const oneDay = 24 * 60 * 60;

export const config: IConfig = {
  url: process.env.REACT_APP_UNLEASH_URL || '',
  clientKey: process.env.REACT_APP_UNLEASH_PROXY_KEY || '',
  refreshInterval: oneDay,
  appName: 'platform.dispenser',
  environment: process.env.REACT_APP_UNLEASH_ENVIRONMENT,
};

export const unleashClient = new UnleashClient(config);

type GetUnleashParams = {
  userId: string | number;
  drugstoreChainId: string | number;
  drugstoreId: string | number;
  drugstoreUF: string | number;
}

export const getUnleash = async ({ userId, drugstoreChainId, drugstoreId, drugstoreUF }: GetUnleashParams): Promise<boolean> => {
  try {
    unleashClient.updateContext({
      userId: String(userId),
      properties: {
        drugstoreChainId: String(drugstoreChainId),
        drugstoreId: String(drugstoreId),
        drugstoreUF: String(drugstoreUF)
      }
    });
    await unleashClient.start();
    return true;
  } catch (error) {
    return false
  }
};
